import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { AppActions } from '../../store/app-actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app-state';
import { CommonService } from '../../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  
  constructor(private store: Store<{app: AppState}>,
              private commonService: CommonService,
              private router: Router) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  
    // Showing full page loader
    this.commonService.setFullPageLoaderVisibility(true);
    
    // Trying to get common data from store
    return this.store.select('app', 'commonData')
    .pipe(
      take(1),
      mergeMap(commonData => {
      
        if ( !commonData ) {
          // Fetching common data from web server
          return this.commonService.getCommonData()
            .pipe(
              map(response => {
                // Saving response to store
                if ( response ){
                  this.store.dispatch(AppActions.setCommonData({commonData: response}));
                }
              
                return response;
              }),
          );
        } else {
          return of(commonData);
        }
      
      }),
      map(commonData => {
        const authorized = commonData?.authorized ?? false;
        
        if ( !authorized ) {
          this.router.navigate(['/login']);
        }
        
        return authorized;
      }),
    );

  }
  
}
